import React, { useState } from 'react';
export const RestartContext = React.createContext(false);

function RestartButtonContext({ children }) {
    const [isRestartTriggered, setIsRestartTriggered] = useState(false);
    const triggerRestart = () => setIsRestartTriggered(true);

    const reseRestartTrigger = () => setIsRestartTriggered(false);
    return (
        <RestartContext.Provider
            value={{ isRestartTriggered, triggerRestart, reseRestartTrigger }}>
            {children}
        </RestartContext.Provider>
    );
}

export default RestartButtonContext;
